// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_VNpVC","list":"list_NQbZE","item":"item_YFYsn"};